import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "./Sidebar.css";
import {
  roleNameBlock,
  nameOnlyBlock,
  blurbBlock,
  songsBlock,
  logoBlock,
  Scrollx_Block_icon,
  info,
} from "../../../assets/icons";

import {
  updateCurrentBlockState,
  moveBlock
} from "../../../Redux/actions/projectActions";
import { useDispatch } from "react-redux";

const getProjectIcon = (blockType) => {
  switch (blockType) {
    case "rolename":
      return roleNameBlock;
    case "nameonly":
      return nameOnlyBlock;
    case "logo":
      return logoBlock;
    case "blurb":
      return blurbBlock;
    case "songs":
      return songsBlock;
    default:
      return nameOnlyBlock;
  }
};
const scrollTo = (parent, child) => {
  let parent1 = document.getElementById(parent);
  let child1 = document.getElementById(child);
  if (child1&&parent1){
    parent1?.scrollTo({
      behavior: "smooth",
      top:
        child1.offsetTop -
        document.getElementById("navbar_1").offsetHeight -
        150,
    });
  }
  
};
const SidebarDD = ({ currentBlockId, blocks, projectData }) => {
  const dispatch = useDispatch();
  const [draggedBlockId, setDraggedBlockId] = useState(null);
  // Hover tooltip, rendered via a portal to <body> (see below) so it escapes
  // .menu-item's `overflow: auto` clip and .Sidebar's `zoom`. { text, top, left }
  const [tooltip, setTooltip] = useState(null);
  const currentBlockIdx = projectData?.currentBlock?.idx;
  const setSelectedBlock = (idx, blockId) => {
    dispatch(updateCurrentBlockState(blockId, idx));
  }

  // Scroll the selected block into view ONLY when the selection changes.
  // Previously this had no dependency array, so it ran on every render — and
  // with the hover-tooltip state added, every mouse-move re-rendered and
  // yanked the list back to the selected block ("returns to top after scroll").
  useEffect(() => {
    try {
       scrollTo("menu-item-paent", "content" + currentBlockIdx);
    } catch (error) {
      console.log(error);
    }
  }, [currentBlockIdx]);
  const handleDragStart = (event, blockId) => {
    setDraggedBlockId(blockId);
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("text/plain", blockId);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  };
  const handleDrop = (event, blockId,targetIdx) => {
    event.preventDefault();
    const sourceIdx = blocks.findIndex((block) => block._id === draggedBlockId);
    if (sourceIdx !== targetIdx) {
      dispatch(moveBlock(sourceIdx, targetIdx));
      dispatch(updateCurrentBlockState(blockId, targetIdx));
    }
    setDraggedBlockId(null);
  };

  return (
    <div className="Sidebar" id="content">

      <div className="w-full xl:h-[60px] 2xl:h-[48px] flex items-center px-3 border-b border-[rgba(255,255,255,.06)] flex-shrink-0" >
        {/* <img className="w-2.5 mr-3" src={Scrollx_Block_icon}  /> */}
      
          <div className=" inline-block group   cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help uppercase xl:text-[14px] 2xl:text-[11.5px] mb-[8px] tracking-[.13em] font-medium font-mono text-white ">Credit Blocks</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[120px] mt-[-30px] font-body p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-left ">
              Manage and navigate through the individual credit sections in your project.
            </span>
          </div>
      </div>
      

      <div className="menu-item " id="menu-item-paent" >
        {blocks?.map((block, idx) => {
          return (
            <div
              className={currentBlockId === block._id ? "menuItemActive font-mono inline-block" : "menuItem font-mono inline-block"}
              id={"content" + idx}
              key={block._id}
              onClick={() => setSelectedBlock(idx, block?._id)}
              draggable={true}
              onDragStart={(event) => handleDragStart(event, block?._id)}
              onDragOver={handleDragOver}
              onDrop={(event) => handleDrop(event, block._id,idx)}
              onMouseEnter={(event) => {
                // Measure the item's real on-screen box (post-zoom) and anchor
                // the tooltip just to its right, vertically centered.
                const r = event.currentTarget.getBoundingClientRect();
                setTooltip({
                  text: block?.block_type,
                  top: r.top + r.height / 2,
                  left: r.right + 8,
                });
              }}
              onMouseLeave={() => setTooltip(null)}
            >
              {/* <img className="icon" src={getProjectIcon(block?.block_type)} alt="" /> */}
              <span className="">{block?.block_name}</span>
            </div>
          );
        })}
      </div>
        <div className="h-[6%] xl:h-[6%] 2xl:h-[6%] px-4 w-full border-t-[1px] border-[#ffffff0e] flex items-center justify-start flex-shrink-0 ">
        <a href="/contact" target="_blank" rel="noopener noreferrer" className="text-[13px] font-medium text-[#a8a4c8] hover:text-[#c4b2ff] transition-colors">
          Need Help?
        </a>
      </div>

      {/* Tooltip is portaled to <body> so it is never clipped by the list's
          overflow and is not scaled by .Sidebar's zoom. `fixed` + the measured
          coords keep it pinned to the hovered item. */}
      {tooltip &&
        createPortal(
          <div
            className="font-body font-medium px-2 py-1.5 rounded-lg bg-[#191824] capitalize text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl max-w-[200px] text-left pointer-events-none"
            style={{
              position: "fixed",
              top: tooltip.top,
              left: tooltip.left,
              transform: "translateY(-50%)",
              zIndex: 9999,
            }}
          >
            {tooltip.text}
          </div>,
          document.body,
        )}
    </div>
  );
};

export default SidebarDD;